// Scheduling clock. A reflexão is "due" (visible) once its `data` (YYYY-MM-DD)
// is on or before *today in Brazil* — not the visitor's local day, and not the
// build server's UTC day. Pinning to America/Sao_Paulo keeps the reveal on the
// same calendar day everywhere. `en-CA` formats as ISO `YYYY-MM-DD`, so the
// returned string compares lexicographically against a frontmatter `data`.
const SP = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo" });

export function todayInSaoPaulo(): string {
  return SP.format(new Date());
}

// True when `data` (YYYY-MM-DD) has arrived relative to `now` (YYYY-MM-DD).
export function isDue(data: string, now: string): boolean {
  return !!data && data <= now;
}
